module.exports = "<div class = \"col-md-12 text-center header-background pointer\" routerLink=\"/login\">\r\n\tiPayOnline\r\n</div>"